<template>
  <div>
    <section class="xlrclh">
      <img class="top-img" src="./../assets/imgs/147/base.png" alt="" />
      <div class="technological-process">
        <div class="rhtj mar-t2">
          <img class="top" src="./../assets/imgs/125/desc-title.png" alt="" />
          <div class="content">
            为深入实施人才强县战略，吸引和聚集一批高层次电商人才来蒲创新创业就业，为高质量建设具有比较优势的人才聚集地提供智力支撑和人才保障，依据《蒲江县加快建设具有比较优势的人才聚集地若干政策措施》（蒲委室〔2023〕4号），结合我县实际，制定本实施细则。
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="./../assets/imgs/147/title1.png" alt="" />
          <div class="content">
            <div class="des" style="margin-top: 0.1rem">
              <div>
                （一）在蒲江县行政区域内工作/服务2年以上（含2年）且所在主体注册地、经营地及税收解缴关系均在蒲江县；
              </div>
            </div>
            <div class="des" style="margin-top: 0.2rem">
              <div>（二）对促进蒲江电商发展成效突出，示范带动作用明显；</div>
            </div>
            <div class="des" style="margin-top: 0.2rem">
              <div>
                （三）政治思想素质好、遵守法纪、诚实守信、德才兼备、爱岗敬业；
              </div>
            </div>
            <div class="des" style="margin-top: 0.2rem">
              <div>（四）个人或者所在单位不存在失信或者不适宜申报情况。</div>
            </div>
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="./../assets/imgs/147/title2.png" alt="" />
          <div class="content">
            评选分三个类别：蒲江县最佳电商运营人才、蒲江县优秀带货主播、蒲江县杰出电商服务人才。
            <div class="des" style="margin-top: 0.8rem">
              <div class="title">一、蒲江县最佳电商运营人才</div>
              <div>
                申报对象在各领域积极应用电子商务，拓展产品销售，在企业负责电商运营，带领所在公司年网络零售额1亿元以上；参评个人或所在单位获得县级（含）以上电商荣誉。
              </div>
              <span style="font-weight: 600">申报需提供材料：</span><br />
              1.个人身份证信息、企业营业执照；<br />
              2.在蒲江县两年及以上参保缴费证明（关联性）；<br />
              3.所在企业年网络零售额1亿元证明（后台销售数据截图或税务机关申报材料）；<br />
              4.个人获得县级（含）以上电商荣誉证明。<br />
            </div>
            <div class="des" style="margin-top: 0.8rem">
              <div class="title">二、蒲江县优秀带货主播</div>
              <div>
                个人账号粉丝量不低于50w，积极参与蒲江直播助农活动；在区域有一定的影响力，积极推广蒲江电商品牌，助力蒲江打造电商物流集聚高地等方面做出贡献，年度带货销售不低于1000万元（数据归口蒲江）；参评个人获得县级（含）以上电商荣誉。
              </div>
              <span style="font-weight: 600">申报需提供材料：</span><br />
              1.个人身份证信息、在蒲江县两年及以上参保缴费证明（关联性）；<br />
              2.账号明细（包括账号名称、粉丝量、创作内容数量）、账号关联性；<br />
              3.参与直播助农活动证明； <br />
              4.账号带货交易数据； <br />
              5.个人获得县级（含）以上电商荣誉证明。<br />
            </div>
            <div class="des" style="margin-top: 0.8rem">
              <div class="title">三、蒲江县杰出电商服务人才</div>
              <div>
                在发展电商新业态，创新电商营销模式，积极参与省市大型电商活动，带领所在团队服务广大电商主体且获大型第三方电商平台认可，累计培育限额以上电商新业态企业3家（含）以上。
              </div>
              <span style="font-weight: 600">申报需提供材料：</span><br />
              1.个人简介、在蒲江县两年及以上参保缴费证明（关联性）；<br />
              2.参与省市电商活动佐证材料；<br />
              3.服务商家和第三方电商平台认可文件；<br />
              4.培育限额以上电商新业态企业证明材料。<br />
            </div>
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="./../assets/imgs/147/title3.png" alt="" />
          <div class="content">
            <div class="des" style="margin-top: 0.1rem">
              <div>（一）给予最高 20 万元的贡献奖励。</div>
            </div>
            <div class="des" style="margin-top: 0.2rem">
              <div>
                （二）同等条件下优先推荐为国家省市电商先进、各级党代表、人大代表和政协委员等。
              </div>
            </div>
            <div class="des" style="margin-top: 0.2rem">
              <div>
                （三）享受《蒲江县加快建设具有比较优势的人才聚集地若干政策措施》中，关于人才安居、子女入学（入园）、就医等配套政策。
              </div>
            </div>
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="./../assets/imgs/147/title4.png" alt="" />
          <div class="content" style="background-color: #fff; font-weight: 600">
            每两年开展一次评选，该年11月30日前。
          </div>
        </div>
        <div class="part-four">
          <img src="../assets/imgs/147/title5.png" class="part-two-title-img" />
          <div class="main-content">
            <div class="part-four-items">
              <div class="title-bg">申报</div>
              <div class="part-four-content1">
                个人自主申报，填写《蒲江县电商领域杰出人才申报表》并附相关佐证材料，一式三份。
              </div>
            </div>
            <div class="part-four-items">
              <div class="title-bg title-bg2">
                <div class="extendFont">初审</div>
              </div>
              <div class="part-four-content1">
                县商务和物流局对申报资料进行初审，初审无误后，公示3日。
              </div>
            </div>
            <div class="part-four-items">
              <div class="title-bg title-bg3">评选</div>
              <div class="part-four-content1">
                县商务和物流局组织专家组对初审通过人选进行评选，择优确定激励对象，评选结果公示5日。
              </div>
            </div>
            <div class="part-four-items" style="border: none">
              <div class="title-bg title-bg4">资金发放</div>
              <div class="part-four-content1">
                经公示无异议的，按程序报批兑现。
              </div>
            </div>
          </div>
        </div>
        <div class="contact" style="margin-top: 0.3rem">
          <img class="top" src="./../assets/imgs/147/title6.png" alt="" />
          <div class="content">
            <div class="number">
              <span class="label">政策咨询电话：</span>
              <div>
                <a href="tel:028-88522209">028-88522209</a>
              </div>
            </div>
            <div class="unit">
              <span class="label">责任单位：</span>
              蒲江县商务和物流局
            </div>
          </div>
        </div>
        <div class="codes">
          <img class="info" src="../assets/imgs/147/code.png" />
        </div>
      </div>
    </section>
    <!-- <call phone="028-84080490"></call> -->
  </div>
</template>

<script>
import call from "../components/call.vue";
export default {
  data() {
    return {};
  },

  components: {
    call,
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";
.circle {
  width: 0.25rem;
  height: 0.25rem;
  border-radius: 50%;
  border: 0.06rem solid #ff6d60;
  margin-right: 0.08rem;
}
.part-four {
  width: 6.85rem;
  background: #e8eeff;
  border-radius: 10px;
  margin-left: 0.02rem;
  margin-top: 0.22rem;
  box-sizing: border-box;
  margin: 0 auto;
  margin-top: 0.22rem;
  border: 0.00001px solid transparent;
  position: relative;
  padding: 1.2rem 0.25rem 0 0.25rem;
  .part-two-title-img {
    width: 7.03rem;
    height: 1.37rem;
    top: 0;
    left: -0.2rem;
    position: absolute;
  }
  .main-content {
    margin-top: 0.34rem;
    width: 6.35rem;
    background: #ffffff;
    border-radius: 10px;
    box-sizing: border-box;
    padding-top: 0.9rem;
    padding-left: 0.35rem;
    padding-right: 0.31rem;

    .part-four-items {
      box-sizing: border-box;
      border-left: 0.02rem dashed #739bfe;
      margin-bottom: 0.6rem;
      padding-left: 0.33rem;
      padding-top: 0.2rem;
      position: relative;
      font-size: 0.26rem;
      // //font-family:: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #4e4e4e;
      line-height: 0.44rem;
      text-align: left;
      padding-bottom: 0.35rem;

      .title-bg {
        position: absolute;
        width: 3.31rem;
        height: 0.55rem;
        top: -0.6rem;
        left: -0.25rem;
        line-height: 0.55rem;
        font-size: 0.34rem;
        font-weight: bold;
        color: #3d5aa3;
        padding-left: 0.58rem;
        background: url(../assets/imgs/144/p1.png) 0 0/100% 100%;
        border: 1px solid #fff;
      }

      .title-bg2 {
        background: url(../assets/imgs/144/p2.png) 0 0/100% 100%;
      }

      .extendFont {
        min-width: 7rem;
        position: absolute;
        top: 50%;
        left: 0.58rem;
        transform: translateY(-50%);
      }

      .title-bg3 {
        background: url(../assets/imgs/144/p3.png) 0 0/100% 100%;
      }

      .title-bg4 {
        background: url(../assets/imgs/144/p4.png) 0 0/100% 100%;
      }

      .title-bg5 {
        background: url(../assets/imgs/144/p5.png) 0 0/100% 100%;
      }

      .title-bg6 {
        background: url(../assets/imgs/144/p6.png) 0 0/100% 100%;
      }

      .inside-title {
        font-weight: 800;
      }

      .part-four-content2 {
        font-weight: bolder;
      }
    }
  }
}
.xlrclh {
  background-color: $base-back;
  padding-top: 0.3rem;
  overflow: hidden;
  .top-img {
    width: 7.26rem;
    height: 4.73rem;
  }

  .technological-process {
    transform: translateY(-1.9rem);

    .rhtj {
      position: relative;

      .top {
        width: 6.86rem;
        height: 2.12rem;
      }

      .content {
        width: 6.85rem;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        background: #ffffff;
        font-size: 0.26rem;
        color: #4e4e4e;
        text-align: left;
        position: relative;
        font-weight: 500;
        line-height: 0.44rem;
      }
    }

    .zccl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.44rem;

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.35rem 0.23rem 0.3rem;
          position: relative;
          text-align: left;
          margin-top: 0.8rem;
          .title {
            position: absolute;
            top: -0.5rem;
            left: 50%;
            transform: translateX(-50%);
            width: 4.74rem;
            height: 0.67rem;
            line-height: 0.67rem;
            display: flex;
            justify-content: center;
            align-content: center;
            font-size: 0.32rem;
            font-weight: bold;
            color: #ffffff;
            border-radius: 1rem;
            background-color: #739bfe;
          }
        }
      }
    }

    .gmlc {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.86rem;
        background: #e8eeff;
        margin: -0.55rem auto;
        padding: 0 0.33rem 0.35rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;

        .circle-box {
          font-size: 0.34rem;
          color: #333;
          font-weight: bold;
          padding-top: 0.5rem;
          text-align: left;
          position: relative;
          .circle {
            width: 0.28rem;
            height: 0.28rem;
            border: 0.06rem solid #ff6d60;
            border-radius: 50%;
            flex-shrink: 0;
            box-sizing: border-box;
            position: absolute;
            left: 0;
            top: 0.62rem;
            display: inline-block;
          }
          .circle-txt {
            text-indent: 1.1em;
          }
        }

        .title {
          font-size: 0.36rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.3rem 0.23rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          line-height: 0.44rem;

          .line-item {
            font-size: 0.26rem;
            position: relative;
            z-index: 3;

            .line {
              position: absolute;
              width: 0.02rem;
              height: 130%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.2rem;
              z-index: 0;
              //   background-color: #739bfe;
            }

            .line-title {
              font-size: 0.3rem;
              font-weight: bold;
              color: #3d5aa3;
            }

            .line-top {
              display: flex;
              width: 4.4rem;
              height: 0.55rem;
              background-image: url(../assets/imgs/25/label.png);
              background-size: 100% 100%;
              z-index: 99;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding-left: 0.1rem;

              .line-num {
                width: 0.44rem;
                height: 0.44rem;
                background: #fff;
                color: #3d5aa3;
                display: inline-flex;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                margin-right: 0.18rem;
                position: relative;
                z-index: 3;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.28rem;
                font-weight: bold;
              }
            }

            .line-content {
              //   border-left: 0.02rem dashed #739bfe;
              padding-bottom: 0.32rem;
              margin-left: 0.2rem;
              padding-left: 0.32rem;
              padding-top: 0.15rem;
              word-break: break-all;
              line-height: 0.44rem;
            }
          }
        }
      }
    }

    .codes {
      margin: 0 auto;
      margin-top: 0.25rem;
      width: 6.85rem;
      background: #fff;
      padding: 0.3rem;
      box-sizing: border-box;
      border-radius: 0.26rem;
      padding-top: 0.28rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #4e4e4e;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .info {
        width: 6.42rem;
        height: 1.94rem;
      }
    }
  }
}
</style>
